import { DateTime } from 'luxon';
import { PtLuxonDate } from '../projects/date.models';

export class WeatherReading {
  id?: number;
  localId?: number;
  status: WeatherReadingStatus;
  statusId: number;
  delayId?: number;
  date: DateTime;
  projectId: number;
  projectName: string;
  projectSetupId: number;
  timeShow: string;
  timeOffset: number;
  isCustomTime: boolean;
  weatherWindow: number;
  windDirection: number;
  windSpeedRecordedAt: number;
  windSpeedRecordedAtAdjustment: number;
  windSpeed: number;
  windSpeed2RecordedAt: number;
  windSpeed2RecordedAtAdjustment: number;
  windSpeed2: number;
  windGustRecordedAt: number;
  windGustRecordedAtAdjustment: number;
  windGust;
  windGust2RecordedAt: number;
  windGust2RecordedAtAdjustment: number;
  windGust2: number;
  averageWindSpeedRecordedAt: number;
  averageWindSpeedRecordedAtAdjustment: number;
  averageWindSpeed: number;
  averageWindSpeed2RecordedAt: number;
  averageWindSpeed2RecordedAtAdjustment: number;
  averageWindSpeed2: number;
  visibility: number;
  significantWaveHeight: number;
  wavePeriod: number;
  waveDirection: number;
  tidalRate: number;
  tidalSet: number;
  airTemperature: number;
  seaTemperature: number;
  precipitationDetails: ProjectWeatherPrecipitationDetailsStatus;
  iceThickness: number;
  lightningObserved?: boolean;
  riskOfLightning: WeatherRiskOfLightningStatus;

  airGap: number;
  vesselRecordedAtHeight1: number;
  vesselRecordedAtHeight2: number;

  wind1RecordedAtCalculatedValue: number;
  wind2RecordedAtCalculatedValue: number;

  customWeatherReadingInstances: any;

  // local only value - created by applying offset to date, should be the same as the UTC time saved in the DB
  sortTime: DateTime;
}

export class WeatherReadingCreationModel {
  dailyLogDate: DateTime;
  date: DateTime; // date is exact datetime of reading, dailyLogDate is the current log day
  timeShow: string;
  projectId: number;
  vesselId: number;
  lockedDay: boolean; // if locked day, then creating a reading will return a new reading to save locally, but won't save it to the db
}

export class WeatherRemarkEditor {
  id?: number;
  projectId: number;
  date: DateTime;
  weatherRemark: string;
  weatherForecast: string;

  // used locally in the filtering process to get the correct data
  dateOffset: number;
}

export class WeatherRemarkGridRow {
  id?: number;
  projectId: number;
  date: DateTime;
  weatherReportSection: string;
  comment: string;
}

export enum WeatherReadingStatus {
  NotComplete = 1,
  InProgress = 2,
  Complete = 3
}

export class WeatherSetup {
  id?: number;
  weatherObservationFrequency: number;
  weatherObservationFrequencyShow: string;
  delayWeatherObservationFrequency: number;
  delayWeatherObservationFrequencyShow: string;
  weatherWindow: boolean;
  weatherWindowMandatory: boolean;
  windDirection: boolean;
  windDirectionMandatory: boolean;
  windSpeedRecordedAt: boolean;
  windSpeedRecordedAtMandatory: boolean;
  windSpeed: boolean;
  windSpeedMandatory: boolean;
  windSpeed2RecordedAt: boolean;
  windSpeed2RecordedAtMandatory: boolean;
  windSpeed2: boolean;
  windSpeed2Mandatory: boolean;
  windGustRecordedAt: boolean;
  windGustRecordedAtMandatory: boolean;
  windGust: boolean;
  windGustMandatory: boolean;
  windGust2RecordedAt: boolean;
  windGust2RecordedAtMandatory: boolean;
  windGust2: boolean;
  windGust2Mandatory: boolean;
  averageWindSpeedRecordedAt: boolean;
  averageWindSpeedRecordedAtMandatory: boolean;
  averageWindSpeed: boolean;
  averageWindSpeedMandatory: boolean;
  averageWindSpeed2RecordedAt: boolean;
  averageWindSpeed2RecordedAtMandatory: boolean;
  averageWindSpeed2: boolean;
  averageWindSpeed2Mandatory: boolean;
  visibility: boolean;
  visibilityMandatory: boolean;
  significantWaveHeight: boolean;
  significantWaveHeightMandatory: boolean;
  wavePeriod: boolean;
  wavePeriodMandatory: boolean;
  waveDirection: boolean;
  waveDirectionMandatory: boolean;
  tidalRate: boolean;
  tidalRateMandatory: boolean;
  tidalSet: boolean;
  tidalSetMandatory: boolean;
  airTemperature: boolean;
  airTemperatureMandatory: boolean;
  seaTemperature: boolean;
  seaTemperatureMandatory: boolean;
  precipitationDetails: boolean;
  precipitationDetailsMandatory: boolean;
  iceThickness: boolean;
  iceThicknessMandatory: boolean;
  lightningObserved: boolean;
  lightningObservedMandatory: boolean;
  riskOfLightning?: boolean;
  riskOfLightningMandatory: boolean;
  projectId: number;
  projectName: string;
  customWeatherReadings: ProjectCustomWeatherReading[] = [];

  // local only - need this so that different projects can have different set of columns when there are multiple projects on a day
  filteredColumns: any[];
}

export class ProjectCustomWeatherReading {
  id: number;
  columnName: string;
  mandatory: boolean;
}

export enum ProjectWeatherPrecipitationDetailsStatus {
  Dry = 1,
  Drizzle = 2,
  Fog = 3,
  LightRain = 4,
  HeavyRain = 5,
  LightShowers = 6,
  HeavyShowers = 7,
  Hail = 8,
  Snow = 9
}

export enum WeatherRiskOfLightningStatus {
  Nil = 1,
  Low = 2,
  Med = 3,
  High = 4
}

export class ProjectWeatherCompleteEditor {
  date: DateTime;
  isComplete: boolean;
}

export class ProjectWeatherCompleteFilters {
  date?: DateTime;
}

export class WeatherLogStandaloneEditor {
  readingId: number;
  readingTime: PtLuxonDate;
  readingTimeOffset: number;
  readingTimeShow: string;
  dailyLogDate: DateTime;
  vesselId: number;
  projectId: number;
}




// WEBPACK FOOTER //
// ./src/models/weather-readings/weather-readings.models.ts